import React from "react";
import styled from "styled-components";

const Empty = ({ children }) => (
  <Wrapper className="text-center">
    <div className="mb-12">
      {Array.from({ length: 2 }, (_, key) => (
        <div className="item" key={key}>
          <div className="item__circle" />
          <div className="item__content" />
        </div>
      ))}
    </div>

    <p className="text-gray fw-bold">{children || "No records yet"}</p>
  </Wrapper>
);

/**
 * styles
 */
const Wrapper = styled.div`
  width: 100%;
  margin: auto;
  max-width: 29rem;

  .item {
    gap: 1rem;
    display: flex;
    padding: 1.5rem;
    max-width: 25rem;
    position: relative;
    align-items: center;
    border-radius: 0.5rem;
    background-color: #fff;
    box-shadow: 0px 4px 28px rgba(0, 0, 0, 0.15);

    &:first-child {
      .item__circle {
        border-color: var(--bs-red-40);
      }
    }

    &:last-child {
      margin-top: -2rem;
      margin-left: auto;

      .item__circle {
        border-color: var(--bs-primary-40);
      }
    }

    &__circle {
      width: 2.5rem;
      display: flex;
      height: 2.5rem;
      flex: 0 0 2.5rem;
      border: solid 4px;
      border-radius: 50%;

      &::before {
        margin: auto;
        content: " ";
        display: block;
        width: 1.625rem;
        height: 1.625rem;
        border-radius: 50%;
        background-color: var(--bs-gray-20);
      }
    }

    &__content {
      width: 100%;

      &::before,
      &::after {
        width: 100%;
        content: " ";
        height: 1rem;
        display: block;
        border-radius: 0.25rem;
        margin-bottom: 0.75rem;
        background-color: var(--bs-gray-20);
      }

      &::after {
        max-width: 10rem;
        margin-bottom: 0;
      }
    }
  }
`;

export default Empty;
